"use client";
import { motion, type MotionProps } from "framer-motion";
import type { PropsWithChildren } from "react";

export default function PageTransition({
  children,
  ...props
}: PropsWithChildren<MotionProps>) {
  return (
    <motion.div
      /**
       * Fade animation
       */
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.25,
      }}
      {...props}
    >
      {children}
    </motion.div>
  );
}
